angular.module('http-interceptor', [])
    /**
     * $http interceptor.
     * Adding version number to all non-servlet requests to ensure browser caches latest version
     * On 440 response - it notifies the Angular app about session timeout
     */
    .config(['$httpProvider', '$qProvider', function ($httpProvider, $qProvider) {
        // Some servlets return html files (template source files)
        var isServletRequest = function (url) {
            return url.indexOf('servlets/') !== -1;
        };
        // Check if embedded template (will be placed in templateCache after loading the host file defining the ng-template)
        var isNgTemplate = function (config) {
            var fromCache = config.cache.get(config.url);
            if (fromCache === undefined) {
                console.log('Not in cache: ' + config.url);
            }
            return config._isTemplate && fromCache !== undefined;
        };
        var addVersionToUrl = function (config, portalVersion) {
            // Add a unique ID to the url so it may be cached by the browser
            // but when releasing a new version each of these files will always
            // be loaded rather than using the old version from cache
            config.url = config.url + '?v=' + portalVersion;
            return config;
        };
        var fileRequestBuffer = [];
        var addVersionToUrlDeferred = function (config, portalVersion) {
            if (!portalVersion) {
                // If the version was not fetched yet from the backend (in the /login/ request)
                // the config is pushed to a buffer and loaded later when a version number is known
                // NOTE: This will fail and never push to buffer - but it seems the Angular interceptor will also handle the file requests
                // Since requests BEFORE we have a version is probably because the angularJS router is trying early to get templates
                // this does not matter as they will be re-run when routing again after authentication
                // return config; // Just to avoid error messages in the log
                var deferred = $qProvider.defer();
                fileRequestBuffer.push({ deferred: deferred, config: config });
                return deferred.promise;
            }
            // If the version number is known we just add it to the URL right away
            return addVersionToUrl(config, portalVersion);
        };
        var retryRequestBuffer = function (portalVersion) {
            // Now that we have the version number we load any buffered file requests
            for (var i = 0; i < fileRequestBuffer.length; ++i) {
                var config = fileRequestBuffer[i].config;
                var deferred = fileRequestBuffer[i].deferred;
                // And add the version number to the URLs
                deferred.resolve(this.addVersionToUrl(config, portalVersion));
            }
            fileRequestBuffer = [];
        };
        var interceptor = ['$rootScope', '$q', 'authenticationSelectorsDowngraded', function ($rootScope, $q, authenticationSelectorsDowngraded) {
                var service = {};
                authenticationSelectorsDowngraded.selectAuthenticate()
                    .subscribe(function (authState) {
                    if (authState !== undefined) {
                        service.viewSessionId = authState.viewSessionId;
                        var noVersion = service.portalVersion === undefined;
                        service.portalVersion = authState.portalVersion;
                        if (noVersion) {
                            retryRequestBuffer(service.portalVersion);
                        }
                    }
                });
                // Intercept all responses to http requests
                service.request = function (config) {
                    // Add a unique ID to the url so it may be cached by the browser
                    // but when releasing a new version each of these files will always
                    // be loaded rather than using the old version from cache
                    // Some html filenames are in fact templates embedded in other files, so adding to the URL will fail
                    if (service.portalVersion === undefined) {
                        console.log('No version when requesting ', config.url);
                    }
                    if ((config.url.indexOf('.html') !== -1 && !isServletRequest(config.url) && !isNgTemplate(config)) ||
                        config.url.indexOf('.js') !== -1 || config.url.indexOf('.json') !== -1) {
                        // Since calling this after version has been fetched (by Angular) the addVersionToUrlDeferred will work
                        config = addVersionToUrlDeferred(config, service.portalVersion);
                    }
                    if (service.viewSessionId !== undefined) {
                        config.headers['View-Session-Id'] = service.viewSessionId;
                    }
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';
                    // setting timeout for each request to 1 min and 5 min for targetstats
                    if (config.url.indexOf('/targetstats/') !== -1) {
                        config.timeout = 300000;
                    }
                    else {
                        config.timeout = 60000;
                    }
                    return config;
                };
                service.response = function (response) {
                    return response;
                };
                service.responseError = function (response) {
                    var deferred = $q.defer();
                    if (response.status === 440) {
                        $rootScope.$broadcast('event:session-timeout');
                        return deferred.promise;
                    }
                    if (response.status === 502) {
                        if (response.config.url.indexOf('/targetstats/') !== -1) {
                            $rootScope.$broadcast('retry-target-stats');
                        }
                    }
                    // otherwise
                    return $q.reject(response);
                };
                return service;
            }];
        $httpProvider.interceptors.push(interceptor);
    }]);
//# sourceMappingURL=http-interceptor.js.map